import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map, catchError, tap, switchMap } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { BaseService } from "./base.service";
import { IDropDownItemViewEdit, IDropDownItemView } from "../interfaces/idropdowns";
import { IAppStore } from "../iappstore";
import { Store } from "@ngrx/store";
import { ISelectItem } from "../interfaces/iselectitem";

/**
 * @whatItDoes A service for performing operations based on drop down items
 *
 * @howToUse To use, inject in to any constructor
 */
@Injectable()
export class DropDownItemService extends BaseService {

    /**
     * Constructor for the service
     * @param http angular Http module
     * @param toastr toastr Module
     * @param authService Authentication Service
     */
    constructor(httpClient: HttpClient, toastr: ToastrService, store: Store<IAppStore>) {
        super(httpClient, toastr, store);
    }

    /**
     * Returns an Observable of the drop down item for the given id
     * @param id The id of the drop down item to retrieve
     */
    getDropDownItem(id: number): Observable<IDropDownItemViewEdit> {
        return super.get(`/api/DropDownItem/${id}`).pipe(map((res: any) => res as IDropDownItemViewEdit));
    }

    /**
     * Returns an Observable of the drop down item created
     * @param dropDownItem The drop down item to create
     */
    create(dropDownItem: IDropDownItemViewEdit): Observable<IDropDownItemViewEdit> {
        return super.post("/api/DropDownItem", dropDownItem).pipe(map((res: any) => res as IDropDownItemViewEdit));
    }

    /**
     * Returns an IDropDownView of response for the drop down being updated
     * @param dropDown The drop down to create
     */
    createMultiple(dropDownId: number, items: ISelectItem[]): Observable<boolean> {
        let obj: any = { dropDownId: dropDownId, items: items };
        return super.post(`/api/DropDownItem/CreateMultiple`, obj).pipe(map((res: any) => res));
    }

    /**
     * Returns an Observable of the drop down item updated
     * @param dropDownItem The drop down item to update
     */
    update(dropDownItem: IDropDownItemViewEdit): Observable<IDropDownItemViewEdit> {
        return super.put("/api/DropDownItem", dropDownItem).pipe(map((res: any) => res as IDropDownItemViewEdit));
    }

    /**
     * Returns an Observable of success or failure for a sorting the drop down items
     * @param dropDownItems The drop down items with their new order
     */
    updateSortOrder(dropDownItems: IDropDownItemView[]): Observable<Response> {
        return super.put("/api/DropDownItemSort", dropDownItems).pipe(map((res: any) => res));
    }

    getPredefinedList(predefinedListId: number): Observable<ISelectItem[]> {
        return super.get(`/api/DropDownItem/PredefinedList/${predefinedListId}`).pipe(map((res: any) => res as ISelectItem[]));
    }
}






